import React, { useEffect } from 'react';
import 'components/customComponents/Layers/SelectIngredients.scss';
import WizardProteinTreeDataSupplier from 'business/tree/WizardProteinTreeDataSupplier';
import Explorer, { TreeControlState } from 'components/explorer';
import ELayersView from 'enums/ELayersView';
import { withTabBackButton, WithTabBackButtonStateProps } from 'components/tab';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
interface SelectProteinTreePathProps extends WithTabBackButtonStateProps {
  setContentView: (contentView: ELayersView) => void;
  setProteinPath: string;
  setParentNode: (...args) => void;
  treeControlState: TreeControlState;
  setTreeControlState: (state: TreeControlState) => void;
  handleOnNodeSelect: (...args) => any;
  handleBackToPreviousScreen: (contentView: ELayersView) => () => void;
}
const shouldRenderNode = (node) => {
  if (node.type === ETreeNodeTypes.RecycleBin) {
    return null;
  }
  return node;
};
function SelectProteinTreePath(props: SelectProteinTreePathProps) {
  const {
    setParentNode,
    handleBackToPreviousScreen,
    treeControlState,
    setTreeControlState,
    handleOnNodeSelect,
    setHandleOnTabBackPress,
  } = props;

  useEffect(() => {
    setHandleOnTabBackPress(() => handleBackToPreviousScreen(ELayersView.SELECTPROTEIN));
  }, [setHandleOnTabBackPress]);

  const globalTreeNodes = { treeNodes: [] };
  const lTreeNodes = [];
  const ALL_SCREENNODE_IDS = 0;

  return (
    <div id="commandpanel-selectproteintreepath-wrapper" className="select-ingredients-tabs">
      <Explorer
        showQuickAccessNode={false}
        setParentNode={setParentNode}
        dataSupplier={WizardProteinTreeDataSupplier}
        globalTreeNodes={globalTreeNodes}
        commonTreeNodes={lTreeNodes}
        gSelectedNode={ALL_SCREENNODE_IDS}
        treeControlState={treeControlState}
        setTreeControlState={setTreeControlState}
        onNodeSelect={handleOnNodeSelect}
        shouldRenderNode={shouldRenderNode}
      />
    </div>
  );
}

export default withTabBackButton(SelectProteinTreePath);
